<template>
  <div class="relative-position " style="margin-top: 98px;" :class="props.class">
    <transition name="fade" mode="out-in">
      <div
        class="q-py-lg inline-padding-140 absolute absolute-top absolute-bottom absolute-left absolute-right z-max bg-white"
        :class="
          $q.screen.width < 788
            ? 'column justify-center items-center'
            : 'row justify-between'
        "
        v-if="loading"
      >
        <div
          class="user-data-wrapper"
          :class="
            $q.screen.width < 788
              ? 'column justify-center items-center'
              : 'row justify-between items-center'
          "
          v-if="props.full_total"
        >
          <q-item-section avatar class="q-pr-none">
            <q-skeleton type="QAvatar" size="80px" />
          </q-item-section>
          <div class="profile-owner q-pl-md" style="width: 150px">
            <div class="profile-owner__name ellipsis flex">
              <q-skeleton type="text" width="100%" />
            </div>
            <div
              class="profile-owner__country flex flex-sm-center flex-xs flex-xs-center justify-md-start"
            >
              <q-skeleton type="text" width="80%" />
            </div>
          </div>
        </div>
        <div
          class="row statistics q-mt-sm q-mt-md-none q-mt-lg-none"
          v-if="props.full_total && props.show_icons"
        >
          <div class="column flex-center">
            <div class="statistics__number q-pb-sm">
              <q-skeleton width="30px" height="30px" />
            </div>
            <div>
              <q-icon name="icon-star" size="sm" />
            </div>
          </div>
          <div class="column flex-center q-mx-xl">
            <div class="statistics__number q-pb-sm">
              <q-skeleton width="30px" height="30px" />
            </div>
            <div>
              <q-icon name="icon-eye" size="sm" />
            </div>
          </div>
          <div class="column flex-center">
            <div class="statistics__number q-pb-sm">
              <q-skeleton width="30px" height="30px" />
            </div>
            <div>
              <q-icon name="icon-thumbs-up" size="sm" />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div
      class="profileSummary q-py-lg inline-padding-140 items-center bg-white relative-position"
      :class="
        $q.screen.width < 788 ? 'column justify-center' : 'row justify-between'
      "
    >
      <div
        class="user-data-wrapper"
        :class="
          $q.screen.width < 788
            ? 'column justify-center items-center'
            : 'row justify-between'
        "
        v-if="props.full_total"
      >
        <q-avatar class="profile_avatar" size="80px" color="grey-4">
          {{ props.full_total.slice(0, 1) }}
        </q-avatar>
        <div class="profile-owner q-pl-md">
          <div class="profile-owner__name ellipsis flex">
            {{ computedFullTotal }}
            <q-icon
              class="q-ml-xs"
              v-if="props.is_verified"
              :size="$q.screen.width <= 640 ? 'xs' : 'sm'"
              color="primary"
              name="icon-verified"
            ></q-icon>
          </div>
          <div class="profile-owner__country">{{ computedCountry }}</div>
        </div>
      </div>
      <div class="row statistics" v-if="props.full_total && props.show_icons">
        <div class="column flex-center">
          <div class="statistics__number q-pb-sm">
            {{ computedReviewTotal }}
          </div>
          <div>
            <q-icon name="icon-star" size="sm" />
            <q-tooltip> التقيمات </q-tooltip>
          </div>
        </div>
        <div class="column flex-center q-mx-xl" v-if="computedIsOwner">
          <div class="statistics__number q-pb-sm">
            {{ computedReviewViewsTotal }}
          </div>
          <div>
            <q-icon name="icon-eye" size="sm" />
            <q-tooltip> المشاهدات </q-tooltip>
          </div>
        </div>
        <div class="column flex-center" v-if="computedIsOwner">
          <div class="statistics__number q-pb-sm">
            {{ computedReviewLikesTotal }}
          </div>
          <div>
            <q-icon name="icon-thumbs-up" size="sm" />
            <q-tooltip> الإعجابات </q-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  useQuasar,
  QTooltip,
  QAvatar,
  QIcon,
  QSkeleton,
  QItemSection,
} from 'quasar';
import { computed } from 'vue';

const props = defineProps({
  class: {
    type: String,
    default: '',
  },
  full_total: {
    type: String,
    default: 'لا اسم',
  },
  country: {
    type: String,
    default: 'لا دولة',
  },
  review_total: {
    type: Number,
    default: 0,
  },
  review_views_total: {
    type: Number,
    default: 0,
  },
  review_likes_total: {
    type: Number,
    default: 0,
  },
  show_icons: {
    type: Boolean,
    default: true,
  },
  is_verified: {
    type: Boolean,
    default: true,
  },
  is_owner: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: true,
  },
});

const $q = useQuasar();

const computedFullTotal = computed(() => props.full_total ?? 'لا اسم');
const computedCountry = computed(() => props.country ?? 'لا دولة');
const computedReviewTotal = computed(() => props.review_total ?? 0);
const computedReviewViewsTotal = computed(() => props.review_views_total ?? 0);
const computedReviewLikesTotal = computed(() => props.review_likes_total ?? 0);
const computedIsOwner = computed(() => props.is_owner ?? false);
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 500ms ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.profile_avatar > div {
  line-height: 75px;
  height: 75px;
}
</style>
